export const VOLUME_SIZE_OPTIONS = [
  { ml: 200, label: "200 ml", sizeId: 2, pointsToGive: 1 },
  { ml: 250, label: "250 ml", sizeId: 2, pointsToGive: 1 },
  { ml: 330, label: "330 ml", sizeId: 2, pointsToGive: 1 },
  { ml: 500, label: "500 ml", sizeId: 2, pointsToGive: 1 },
  { ml: 1000, label: "1000 ml", sizeId: 3, pointsToGive: 3 },
]

const VOLUME_RULES = Object.fromEntries(
  VOLUME_SIZE_OPTIONS.map((option) => [option.ml, { sizeId: option.sizeId, pointsToGive: option.pointsToGive }]),
)

export function getVolumeOptionByMl(ml) {
  if (ml === null || ml === undefined || ml === "") return null
  const parsed = typeof ml === "string" ? parseInt(ml, 10) : ml
  if (Number.isNaN(parsed)) return null
  return VOLUME_SIZE_OPTIONS.find((option) => option.ml === parsed) ?? null
}

export function detectVolumeFromTitle(title) {
  if (!title) {
    return { detectedMl: null, sizeId: null, pointsToGive: null }
  }

  const mlMatch = title.match(/(\d+)\s*ml\b/i)
  if (mlMatch) {
    const detectedMl = parseInt(mlMatch[1], 10)
    const rule = VOLUME_RULES[detectedMl]
    if (rule) {
      return { detectedMl, sizeId: rule.sizeId, pointsToGive: rule.pointsToGive }
    }
    return { detectedMl, sizeId: null, pointsToGive: null }
  }

  const literMatch = title.match(/(\d+(?:\.\d+)?)\s*l\b/i)
  if (literMatch) {
    const detectedMl = Math.round(parseFloat(literMatch[1]) * 1000)
    const rule = VOLUME_RULES[detectedMl]
    if (rule) {
      return { detectedMl, sizeId: rule.sizeId, pointsToGive: rule.pointsToGive }
    }
    return { detectedMl, sizeId: null, pointsToGive: null }
  }

  return { detectedMl: null, sizeId: null, pointsToGive: null }
}

export function resolveVolumeSize(title, manualMl) {
  const manualOption = getVolumeOptionByMl(manualMl)
  if (manualOption) {
    return {
      detectedMl: manualOption.ml,
      sizeId: manualOption.sizeId,
      pointsToGive: manualOption.pointsToGive,
      source: "manual",
    }
  }

  const detected = detectVolumeFromTitle(title)
  return {
    ...detected,
    source: detected.sizeId != null ? "parser" : null,
  }
}

export function isValidForCodesImport(volumeInfo) {
  return volumeInfo.sizeId != null && volumeInfo.pointsToGive != null
}
